export default "/_nuxt/e0de38a3f3cf90002bb37ce6fb86f856.svg";